import {Component} from "react";
import {connect} from "react-redux";
import {VrgPage} from "../VrgPage";
import UserIcon from "../../widgets/UserIcon";
import {baseUrl} from "../../../config";
import {getPostRequest} from "../../service/FetchUtils";
import download from "downloadjs";

import {
    initCompassUsers,
    updateCompassDraggedUser,
    placeCompassUser,
    removeCompassUser,
    updateCompassTitle,
    updateCompassTopLabel,
    updateCompassBottomLabel,
    updateCompassLeftLabel,
    updateCompassRightLabel,
    resetCompass,
    updateCompassTopLeftColor,
    updateCompassTopRightColor,
    updateCompassBottomLeftColor,
    updateCompassBottomRightColor,
    restoreCompassState,
} from "../../store/slices/CompassSlice";

import './CompassPage.css';

class CompassPage extends Component {

    state = {
        status: '',
    }

    componentDidMount() {
    const savedCompass = localStorage.getItem('vrg-compass-state');

    if (savedCompass) {
        this.props.restoreCompassState(JSON.parse(savedCompass));
    }

    fetch(`${baseUrl}/users`)
        .then(response => response.json())
        .then(data => {
            if (!savedCompass) {
                this.props.initCompassUsers(data);
            }
        });
}

    startDrag(user) {
        this.props.updateCompassDraggedUser(user);
    }

    componentDidUpdate() {
    localStorage.setItem('vrg-compass-state', JSON.stringify({
        users: this.props.users,
        placedUsers: this.props.placedUsers,
        title: this.props.title,
        topLabel: this.props.topLabel,
        bottomLabel: this.props.bottomLabel,
        leftLabel: this.props.leftLabel,
        rightLabel: this.props.rightLabel,
        topLeftColor: this.props.topLeftColor,
        topRightColor: this.props.topRightColor,
        bottomLeftColor: this.props.bottomLeftColor,
        bottomRightColor: this.props.bottomRightColor,
    }));
}
    dropOnCompass(event) {
        event.preventDefault();

        if (!this.props.draggedUser) {
            return;
        }

        const rect = event.currentTarget.getBoundingClientRect();

        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;

        this.props.placeCompassUser({
            user: this.props.draggedUser,
            x,
            y,
        });

        this.props.updateCompassDraggedUser(undefined);
    }

    exportCompass() {
        this.setState({status: 'loading'});

        fetch(`${baseUrl}/render/compass`, getPostRequest({
            title: this.props.title,
            topLabel: this.props.topLabel,
            bottomLabel: this.props.bottomLabel,
            leftLabel: this.props.leftLabel,
            rightLabel: this.props.rightLabel,
            topLeftColor: this.props.topLeftColor,
            topRightColor: this.props.topRightColor,
            bottomLeftColor: this.props.bottomLeftColor,
            bottomRightColor: this.props.bottomRightColor,
            users: this.props.placedUsers,
        }))
            .then(response => response.blob())
            .then(blob => {
                download(blob, 'compass.png', 'image/png');
                this.setState({status: ''});
            })
            .catch(err => {
                console.error(err);
                this.setState({status: ''});
            });
    }

    renderCompassControls() {
        return (
            <div className="compass-board-controls">
                <input
                    className="compass-color-input"
                    type="color"
                    value={this.props.topLeftColor}
                    onChange={(e) => this.props.updateCompassTopLeftColor(e.target.value)}
                    title="Top left color"
                />

                <input
                    className="compass-color-input"
                    type="color"
                    value={this.props.topRightColor}
                    onChange={(e) => this.props.updateCompassTopRightColor(e.target.value)}
                    title="Top right color"
                />

                <input
                    className="compass-color-input"
                    type="color"
                    value={this.props.bottomLeftColor}
                    onChange={(e) => this.props.updateCompassBottomLeftColor(e.target.value)}
                    title="Bottom left color"
                />

                <input
                    className="compass-color-input"
                    type="color"
                    value={this.props.bottomRightColor}
                    onChange={(e) => this.props.updateCompassBottomRightColor(e.target.value)}
                    title="Bottom right color"
                />

                <button
                    type="button"
                    className="vrg-button vrg-button-primary btn btn-primary"
                    onClick={() => this.exportCompass()}
                    disabled={this.state.status === 'loading'}
                >
                    Export
                </button>

                <button
                    type="button"
                    className="vrg-button btn btn-primary"
                    onClick={() => this.props.resetCompass()}
                >
                    Reset
                </button>
            </div>
        );
    }

    render() {
        return (
            <VrgPage page={'compass'}>
                <div className="compass-page">
                    <div className="tierlist-header-container compass-header-container">
                        <input
                            className="vrg-form-control tierlist-header-title-input form-control"
                            value={this.props.title}
                            onChange={(e) => this.props.updateCompassTitle(e.target.value)}
                            placeholder="Compass title"
                        />

                        <input
                            className="vrg-form-control compass-header-input form-control"
                            value={this.props.topLabel}
                            onChange={(e) => this.props.updateCompassTopLabel(e.target.value)}
                            placeholder="Top label"
                        />

                        <input
                            className="vrg-form-control compass-header-input form-control"
                            value={this.props.bottomLabel}
                            onChange={(e) => this.props.updateCompassBottomLabel(e.target.value)}
                            placeholder="Bottom label"
                        />

                        <input
                            className="vrg-form-control compass-header-input form-control"
                            value={this.props.leftLabel}
                            onChange={(e) => this.props.updateCompassLeftLabel(e.target.value)}
                            placeholder="Left label"
                        />

                        <input
                            className="vrg-form-control compass-header-input form-control"
                            value={this.props.rightLabel}
                            onChange={(e) => this.props.updateCompassRightLabel(e.target.value)}
                            placeholder="Right label"
                        />
                    </div>

                    <div className="compass-layout">
                        <div className="compass-work-area">
                            <div
                                className="compass-board"
                                style={{
                                    background: `
                                        linear-gradient(to bottom right, ${this.props.topLeftColor}, transparent 50%, ${this.props.bottomRightColor}),
                                        linear-gradient(to bottom left, ${this.props.topRightColor}, transparent 50%, ${this.props.bottomLeftColor})
                                    `
                                }}
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={(e) => this.dropOnCompass(e)}
                            >
                                <div className="compass-axis-x"/>
                                <div className="compass-axis-y"/>

                                <div className="compass-label compass-label-top">{this.props.topLabel}</div>
                                <div className="compass-label compass-label-bottom">{this.props.bottomLabel}</div>
                                <div className="compass-label compass-label-left">{this.props.leftLabel}</div>
                                <div className="compass-label compass-label-right">{this.props.rightLabel}</div>

                                {this.props.placedUsers.map(user => (
                                    <div
                                        key={user.id}
                                        className="compass-user"
                                        draggable={true}
                                        onDragStart={() => this.startDrag(user)}
                                        onDoubleClick={() => this.props.removeCompassUser(user)}
                                        style={{
                                            left: `${user.compassX}%`,
                                            top: `${user.compassY}%`,
                                        }}
                                    >
                                        <UserIcon 
                                            user={user} 
                                            ignoreMobile={true} 
                                            noCloning={true}
                                            disableUserModal={true}
                                            />
                                    </div>
                                ))}
                            </div>

                            {this.renderCompassControls()}
                        </div>

                        <div className="compass-user-pool">
                            {this.props.users
                                .filter(user => !this.props.searchValue ||
                                    user.name.toLowerCase().includes(this.props.searchValue.toLowerCase())
                                )
                                .map(user => (
                                    <div
                                        key={user.id}
                                        draggable={true}
                                        onDragStart={() => this.startDrag(user)}
                                    >
                                        <UserIcon 
                                            user={user} 
                                            ignoreMobile={true} 
                                            noCloning={true}
                                            disableUserModal={true}
                                            />
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </VrgPage>
        )
    }
}

function mapStateToProps(state) {
    return {
        users: state.compass.users,
        placedUsers: state.compass.placedUsers,
        draggedUser: state.compass.draggedUser,
        searchValue: state.search.filter,

        title: state.compass.title,
        topLabel: state.compass.topLabel,
        bottomLabel: state.compass.bottomLabel,
        leftLabel: state.compass.leftLabel,
        rightLabel: state.compass.rightLabel,

        topLeftColor: state.compass.topLeftColor,
        topRightColor: state.compass.topRightColor,
        bottomLeftColor: state.compass.bottomLeftColor,
        bottomRightColor: state.compass.bottomRightColor,
    }
}

export default connect(mapStateToProps, {
    initCompassUsers,
    updateCompassDraggedUser,
    placeCompassUser,
    removeCompassUser,
    updateCompassTitle,
    updateCompassTopLabel,
    updateCompassBottomLabel,
    updateCompassLeftLabel,
    updateCompassRightLabel,
    updateCompassTopLeftColor,
    updateCompassTopRightColor,
    updateCompassBottomLeftColor,
    updateCompassBottomRightColor,
    restoreCompassState,
    resetCompass,
})(CompassPage);